export default __webpack_public_path__ + "static/media/block_white.be7b0de3.svg";